import { Fragment } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routes } from './Routes';
import AppLayout from '../Layout/Layout';

const LayoutRoutes = ({ role }) => {
  const allowedRoutes = routes.filter(
    (route) => !route.roles || route.roles.includes(role)
  );

  const defaultRedirect = role === "ASSISTANT" ? "/order" : "/user"; 
  return (
    <Routes>
      {allowedRoutes.map(({ path, Component }, i) => (
        <Fragment key={i}>
          <Route element={<AppLayout />}>
            <Route path={path} element={Component} />
          </Route>
        </Fragment>
      ))}
      
      <Route path="*" element={<Navigate to={defaultRedirect} replace />} />
    </Routes>
  );
};

export default LayoutRoutes;
